import Checkbox from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';
import { colorPalette } from 'stylesheet';

export const StyledCheckbox = styled(Checkbox)({
  color: colorPalette.blueMain,
  '&.Mui-checked': { color: colorPalette.blueMain },
});
